export enum PackageManager {
	NPM = 'npm',
	YARN = 'yarn',
	PNPM = 'pnpm',
}

export interface PackageOptions {
	name: string;
	directory: string;
	packageManager: PackageManager;
	productionOnly: boolean;
}

export interface PackageResult {
	fileName: string;
	size: number;
	dependencies: string[];
}
